import { Table } from 'antd';
import cn from 'classnames';
import TableLoader from 'components/Sceletons/TableLoader';
import IRecycleBinItem from 'interfaces/IRecycleBinItem';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store/hook';
import classes from './RecycleBinTable.module.scss';
import { columnsRecycle } from './columnsAndFilters/columnsAndFilters';


type RecycleBinTableProps = {
  data: IRecycleBinItem[];
  selectedRowKeys: React.Key[];
  onSelectionChange: (keys: React.Key[]) => void;
  isLoading: boolean;
  isDeleting: boolean;
};

const RecycleBinTable = ({ data, selectedRowKeys, onSelectionChange, isLoading, isDeleting }: RecycleBinTableProps) => {
  const { t } = useTranslation();
  const { userData } = useAppSelector((store) => store.userData);

  const columns = columnsRecycle(t, data, userData);
  
  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys: React.Key[]) => {
      onSelectionChange(newSelectedRowKeys);
    },
  };

  if (isLoading) {
    return <TableLoader padding={'0px'} height={window.innerHeight - 84} margin={'-20px 0px 0px 0px'} />;
  }

  return (
    <div className={classes.tableWrapper}>
      <div
        className={cn(classes.tableArea,
          isLoading || isDeleting ? classes.tableRowLoading : 'empty')
        }
      >
        <Table
          columns={columns}
          dataSource={data}
          rowSelection={rowSelection}
          rowKey='id'
          // sortDirections={['ascend', 'descend', 'ascend']}
          // pagination={{ pageSize: 20, showSizeChanger: false }}
          pagination={false}
          scroll={{
            y: 'calc(100dvh - 194px)',
            // x: 'max-content'
          }}
          size='small'
          rowClassName={(record) => record.type === 'folder' ? classes.folderRow : classes.fileRow}
        />
      </div>
    </div>
  );
};

export default RecycleBinTable;
